module.exports = __webpack_public_path__ + "img/menu_tr_new.2e29e608.png";